<template>
  <v-container>
    <v-row class="ma-1 pa-1">
      <v-col>
        <template>
          <v-card>
            <v-card-text>
              <v-row class="ma-2">
                <v-col cols="12">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="date"
                        label="Дата"
                        append-icon="mdi-calendar-month"
                        readonly
                        clearable
                        v-bind="attrs"
                        v-on="on"
                      >
                        <template #prepend-inner>
                          <v-icon x-small color="red">mdi-hexagram</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="date">
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false">
                        Отмена
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(date)"
                      >
                        Сохранить
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-autocomplete
                class="ma-2 pa-2"
                height="50%"
                v-model="obj"
                :items="objs"
                item-value="ID"
                item-text="NAME"
                label="Объект"
                required
              >
                <template #prepend-inner>
                  <v-icon x-small color="red">mdi-hexagram</v-icon>
                </template>
              </v-autocomplete>
              <v-autocomplete
                      class="ma-2 pa-2"
                      height="50%"
                      v-model="objWork"
                      :items="objWorks"
                      label="Вид работ"
                      required
                    >
                      <template #prepend-inner>
                        <v-icon x-small color="red">mdi-hexagram</v-icon>
                      </template>
                    </v-autocomplete>
              <template v-for="(item, index) in items">
                <div
                  style="border: 1px solid black; padding: 12px"
                  :key="index"
                >
                  <template>
                    <div style="padding: 2 px">
                      <v-card-subtitle
                        >Использованный материал в работу</v-card-subtitle
                      >
                      <v-row>
                        <v-select
                          class="ma-2 pa-2"
                          v-model="item.typeMaterial"
                          :items="typeMaterials"
                          label="Вид материала"
                          outlined
                          item-value="ID"
                          item-text="NAME"
                          dense
                          @change="getPlan('material', item)"
                        ></v-select>
                        <v-select
                          class="ma-2 pa-2"
                          v-model="item.unitMaterial"
                          :items="units"
                          label="Единица измерения"
                          outlined
                          dense
                        ></v-select>
                        <v-text-field
                          class="ma-2 pa-2"
                          counter
                          type="number"
                          label="План"
                          v-model="item.planMaterial"
                          disabled
                          required
                          outlined
                          dense
                        >
                        </v-text-field>
                        <v-text-field
                          class="ma-2 pa-2"
                          counter
                          type="number"
                          label="Факт"
                          v-model="item.quantityMaterial"
                          required
                          outlined
                          dense
                          @input="
                            item.diffMaterial =
                              item.planMaterial - item.quantityMaterial
                          "
                        >
                        </v-text-field>
                        <v-text-field
                          class="ma-2 pa-2"
                          counter
                          type="number"
                          label="Разница"
                          v-model="item.diffMaterial"
                          required
                          disabled
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-row>
                    </div>
                  </template>
                  <template>
                    <div style="padding: 2 px">
                      <v-card-subtitle
                        >Использованная техника под данный вид работ
                      </v-card-subtitle>
                      <v-row>
                        <v-select
                          class="ma-2 pa-2"
                          v-model="item.typeTech"
                          :items="typeTechs"
                          item-value="ID"
                          item-text="NAME"
                          label="Вид техники"
                          outlined
                          dense
                          @change="getPlan('tech', item)"
                        ></v-select>
                        <v-select
                          class="ma-2 pa-2"
                          v-model="item.unitTech"
                          :items="units"
                          label="Единица измерения"
                          outlined
                          dense
                        ></v-select>
                        <v-textarea
                          class="ma-2 pa-2"
                          counter
                          type="number"
                          label="Что делала техника"
                          v-model="item.commentTech"
                          required
                          outlined
                          dense
                        >
                        </v-textarea>
                        <v-text-field
                          class="ma-2 pa-2"
                          counter
                          type="number"
                          label="План"
                          v-model="item.planTech"
                          required
                          disabled
                          outlined
                          dense
                        >
                        </v-text-field>
                        <v-text-field
                          class="ma-2 pa-2"
                          counter
                          type="number"
                          label="Факт"
                          v-model="item.quantityTech"
                          required
                          outlined
                          dense
                          @input="
                            item.diffTech = item.planTech - item.quantityTech
                          "
                        >
                        </v-text-field>
                        <v-text-field
                          class="ma-2 pa-2"
                          counter
                          type="number"
                          label="Разница"
                          v-model="item.diffTech"
                          required
                          outlined
                          disabled
                          dense
                        >
                        </v-text-field>
                      </v-row>
                    </div>
                  </template>
                  <template>
                    <div style="padding: 2 px">
                      <v-card-subtitle
                        >Работа задействованных рабочих</v-card-subtitle
                      >
                      <v-row>
                        <v-select
                          class="ma-2 pa-2"
                          v-model="item.unitWorkers"
                          :items="units"
                          label="Единица измерения"
                          outlined
                          dense
                        ></v-select>
                        <v-text-field
                          class="ma-2 pa-2"
                          counter
                          type="number"
                          label="План"
                          v-model="item.planWorkers"
                          required
                          disabled
                          outlined
                          dense
                        >
                        </v-text-field>
                        <v-text-field
                          class="ma-2 pa-2"
                          counter
                          type="number"
                          label="Факт"
                          v-model="item.quantityWorkers"
                          required
                          outlined
                          dense
                        >
                        </v-text-field>
                        <v-text-field
                          class="ma-2 pa-2"
                          counter
                          type="number"
                          label="Разница"
                          v-model="item.diffWorkers"
                          required
                          outlined
                          disabled
                          dense
                          @input="
                            item.diffWorkers =
                              item.planWorkers - item.quantityWorkers
                          "
                        >
                        </v-text-field>
                      </v-row>
                    </div>
                  </template>
                  <v-btn
                    @click="
                      items.push({
                        typeMaterial: '',
                        typeTech: '',
                        unitMaterial: '',
                        unitTech: '',
                        unitWorkers: '',
                        planMaterial: 0,
                        planWorkers: 0,
                        planTech: 0,
                        quantityMaterial: 0,
                        quantityWorkers: 0,
                        quantityTech: 0,
                        diffWorkers: 0,
                        diffMaterial: 0,
                        diffTech: 0,
                        commentTech: '',
                      })
                    "
                    >Добавить</v-btn
                  >
                </div>
              </template>
            </v-card-text>
          </v-card>
        </template>
      </v-col>
    </v-row>
    <v-row class="ma-1 pa-1">
      <v-col>
        <v-btn color="success" @click="save" :disabled="loading">
          Создать
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import { BX24 } from "bx24";

export default {
  name: "Blank-add",
  data: () => ({
    loading: false,
    date: "",
    normalDate: "",
    menu: false,
    dialog: false,
    quantityWork: 0,
    unitWork: "",
    items: [
      {
        typeMaterial: "",
        typeTech: "",
        unitWork: "",
        unitMaterial: "",
        unitTech: "",
        unitWorkers: "",
        planMaterial: 0,
        planWorkers: 0,
        planTech: 0,
        quantityMaterial: 0,
        quantityWorkers: 0,
        quantityTech: 0,
        quantityWork: 0,
        diffWorkers: 0,
        diffMaterial: 0,
        diffTech: 0,
        commentTech: "",
      },
    ],
    units: [
      "шт",
      "тн",
      "кг",
      "л",
      "м.п.",
      "м2",
      "м3",
      "ч/ч",
      "маш/час",
      "смена",
      "сутки",
    ],
    obj: "",
    objs: [],
    objWork: "",
    objWorks: [],
    typeMaterials: [],
    typeTechs: [],
    auth: "",
    domen: "",
    url: "https://citystroi.bitrix24.ru/rest/73/gjdt5g3y10jxw3r9/",
  }),
  methods: {
    async normalizeDate() {
      try {
        const date = this.date.split("-");
        console.log(date);
        this.normalDate = date[2] + "." + date[1] + "." + date[0] + " 00:00:00";
      } catch (e) {
        console.log(e);
      }
    },
    async save() {
      try {
        this.loading = true;
        if (this.date) {
          await this.normalizeDate();
          for (const index in this.items) {
            const params = {
              IBLOCK_TYPE_ID: "lists",
              IBLOCK_ID: "153",
              ELEMENT_CODE: `item${this.obj}&${
                this.objWork
              }/${new Date()}/${index}`,
              FIELDS: {
                NAME: "app",
                PROPERTY_1409: this.normalDate,
                PROPERTY_1411: this.obj,
                PROPERTY_1413: this.objWork,
                PROPERTY_1445: this.items[index].typeMaterial
                  ? this.typeMaterials.filter(
                      (e) => e.ID == this.items[index].typeMaterial
                    )[0].NAME
                  : "",
                PROPERTY_1419: this.items[index].planMaterial,
                PROPERTY_1421: this.items[index].quantityMaterial,
                PROPERTY_1423: this.items[index].diffMaterial,
                PROPERTY_1425: this.items[index].unitMaterial,
                PROPERTY_1427: this.items[index].typeTech
                  ? this.typeTechs.filter(
                      (e) => e.ID == this.items[index].typeTech
                    )[0].NAME
                  : "",
                DETAIL_TEXT: this.items[index].commentTech,
                PROPERTY_1429: this.items[index].planTech,
                PROPERTY_1431: this.items[index].quantityTech,
                PROPERTY_1433: this.items[index].diffTech,
                PROPERTY_1435: this.items[index].unitTech,
                PROPERTY_1437: this.items[index].planWorkers,
                PROPERTY_1439: this.items[index].quantityWorkers,
                PROPERTY_1451: this.items[index].diffWorkers,
                PROPERTY_1447: this.items[index].unitWorkers,
              },
              auth: this.auth.ACCESS_TOKEN,
            };
            const method = "lists.element.add";
            await axios.post(this.url + method, params);
          }

          this.date = "";
          this.normalDate = "";
          this.obj = "";
          this.objWork = "";
          this.objWorks = [];
          this.typeMaterials = [];
          this.typeTechs = [];
          this.items = [
            {
              typeMaterial: "",
              typeTech: "",
              unitWork: "",
              unitMaterial: "",
              unitTech: "",
              unitWorkers: "",
              planMaterial: "",
              planWorkers: "",
              planTech: "",
              quantityMaterial: "",
              quantityWorkers: "",
              quantityTech: "",
              quantityWork: "",
              diffWorkers: "",
              diffMaterial: "",
              diffTech: "",
              commentTech: "",
            },
          ];
        } else {
          alert("Вы не указали дату!");
        }
        this.loading = false;
      } catch (e) {
        console.log(e);
      }
    },
    async getObj() {
      try {
        this.objs = [];
        const params = {
          IBLOCK_TYPE_ID: "lists",
          IBLOCK_ID: "97",
          auth: this.auth.ACCESS_TOKEN,
        };
        const method = "lists.element.get";
        let i = 1;
        let next = 0;
        while (i > 0) {
          params.start = next;
          const objData = await axios.post(this.url + method, params);
          next = objData.data.next;
          this.objs.push(...objData.data.result);
          if (!next) {
            i = 0;
          }
        }
        //console.log(this.obj)
        this.objs.sort((a, b) => {
          if (a["NAME"] < b["NAME"]) {
            return -1;
          }
          if (a["NAME"] > b["NAME"]) {
            return 1;
          }
          // a должно быть равным b
          return 0;
        });
      } catch (e) {
        console.log(e);
      }
    },
    async getStatObj() {
      try {
        console.log("getStatObj");
        try {
          this.objStats = [];
          const params = {
            IBLOCK_TYPE_ID: "lists",
            IBLOCK_ID: "97",
            ELEMENT_ID: this.obj,
            auth: this.auth.ACCESS_TOKEN,
          };
          const method = "lists.element.get";
          const objData = await axios.post(this.url + method, params);
          console.log({ objData });
          const statObjData = Object.values(
            objData.data.result[0].PROPERTY_1353
          )[0];
          for (const stat of statObjData.split(";")) {
            let pushStat = stat.replace(/[^a-zа-яё0-9\s]/gi, "");
            pushStat = pushStat.trim();
            if (pushStat != " " || pushStat != "") this.objWorks.push(pushStat);
          }

          this.objWorks.sort((a, b) => {
            if (a["NAME"] < b["NAME"]) {
              return -1;
            }
            if (a["NAME"] > b["NAME"]) {
              return 1;
            }
            // a должно быть равным b
            return 0;
          });
        } catch (e) {
          console.log(e);
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getType(type) {
      try {
        let iblock = 103;
        if (type === "material") {
          iblock = 107;
          this.typeMaterials = [];
        } else {
          this.typeTechs = [];
        }
        const params = {
          IBLOCK_TYPE_ID: "lists",
          IBLOCK_ID: iblock,
          auth: this.auth.ACCESS_TOKEN,
        };
        const method = "lists.element.get";
        let i = 1;
        let next = 0;
        while (i > 0) {
          params.start = next;
          const objData = await axios.post(this.url + method, params);
          next = objData.data.next;
          if (type == "material")
            this.typeMaterials.push(...objData.data.result);
          else this.typeTechs.push(...objData.data.result);
          if (!next) {
            i = 0;
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getPlan(type, item) {
      try {
        console.log({ item });
        const units = {
          1509: "м3",
          1511: "м2",
          1513: "шт",
          1515: "м.п.",
          1517: "сутки",
          1519: "маш/час",
          1521: "смена",
          1593: "тн",
          1595: "кг",
          1597: "л",
          1599: "ч/ч",
        };
        let entity = item.typeTech;
        if (type == "material") entity = item.typeMaterial;

        const params = {
          IBLOCK_TYPE_ID: "lists",
          IBLOCK_ID: "145",
          FILTER: {
            PROPERTY_1347: this.obj,
            PROPERTY_1361: this.objWork,
          },
          auth: this.auth.ACCESS_TOKEN,
        };
        if (type == "material") params.FILTER["PROPERTY_1341"] = entity;
        else params.FILTER["PROPERTY_1339"] = entity;
        console.log({ params });
        const method = "lists.element.get";
        const data = await axios.post(this.url + method, params);
        console.log({ data });
        if (type == "material") {
          item.planMaterial = Object.values(
            data.data.result[0].PROPERTY_1363
          )[0];
          item.unitMaterial =
            units[Object.values(data.data.result[0].PROPERTY_1343)[0]];
        } else {
          item.planTech = Object.values(data.data.result[0].PROPERTY_1363)[0];
          item.unitTech =
            units[Object.values(data.data.result[0].PROPERTY_1343)[0]];
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
  watch: {
    async obj(newObj, oldObj) {
      if (newObj !== oldObj || newObj != "") {
        await this.getStatObj();
      }
    },
  },
  async mounted() {
    const bx24 = new BX24();
    this.auth = await bx24.getAuth();
    this.url = `https://${this.auth.DOMAIN}/rest/`;
    this.domen = this.auth.DOMAIN;
    await this.getObj();
    await this.getType("material");
    await this.getType("tech");
  },
};
</script>
